import { createFileRoute } from '@tanstack/react-router'

import { CaseStudyLayout } from '../components/CaseStudyLayout'
import { oneMind } from '../caseStudies/oneMind'
import { caseStudyHead } from '../caseStudySeo'

export const Route = createFileRoute('/1Mind')({
  head: () => caseStudyHead(oneMind.content),
  component: OneMindPage,
})

function OneMindPage() {
  return <CaseStudyLayout content={oneMind.content} />
}
